import React from 'react';
import Layout from '../Components/Layout/Layout';
import Dashboard from '../Components/Dashboard/Dashboard';

function DashboardPage() {
  return (
    <Layout>
      <Dashboard />
    </Layout>
  );
}

export default DashboardPage;
